import { render } from "./TheHeader.vue?vue&type=template&id=3987c198"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"
script.render = render

export default script